<template>
  <BookBlock :list="currentBorrow" :type="1" @onLoad="onLoad" ref="bookChild" flag='order'/>
</template>

<script>
import {defineComponent,onMounted, ref} from "vue";
import BookBlock from './BookBlock';
import {getLoans} from '@/api/users';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'CurrentBorrow',
  components: {
      BookBlock,
  },
	setup(){
      const currentBorrow = ref([]);
      const bookChild = ref();
      let total = 0;
      let page = 1;
      const onLoans = ()=>{
          getLoans(page, 10)
              .then(data => {
                  if(data){
                      total = data.total;
                      if(isNotEmpty(data.items)){
                          const isbns = [];
                          let arr = [];
                          data.items.forEach(item  => {
                              if(isNotEmpty(item.pdaOrderDetl) && isNotEmpty(item.pdaOrderDetl.book)){
                                  let temp = item.pdaOrderDetl.book;
                                  Object.assign(temp, {loanDate: item.loanDate,dueDate: item.dueDate ? item.dueDate.substring(0,10) : "",vendorName:item.pdaOrderDetl?.vendor?.vendorName ?? ''});
                                  arr.push(temp);
                                  if(isNotEmpty(item.pdaOrderDetl.book.isbn)){
                                      isbns.push(item.pdaOrderDetl.book.isbn);
                                  }
                              }else {
                                  arr.push({});
                              }
                          });
                          if(isNotEmpty(isbns)){
                              setCovers(isbns,arr);
                          }
                          currentBorrow.value = currentBorrow.value.concat(arr);
                      }
                      page++;
                  }
                  if(isNotEmpty(bookChild.value)){
                      bookChild.value.loading = false; // 加载状态结束
                      bookChild.value.finished = currentBorrow.value.length >= total;
                  }
              })
              .catch((error) => {
                  console.error(error);
              });
      };
      const onLoad =() => {
          if(currentBorrow.value.length < total){
              onLoans();
          }else {
              bookChild.value.loading = false; // 加载状态结束
              bookChild.value.finished = currentBorrow.value.length >= total;
          }
      };
      onMounted(() => {
          onLoans();
      });
	    return{
          currentBorrow,
          onLoad,
          bookChild,
	    }
	},
});
</script>

<style scoped lang="less">

</style>
